import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { getGuestPortalPrivacyPolicy, getTourRequestPrivacyPolicy, GP_PRIVACY_POLICY } from 'api/privacyPolicy';
import { setPrivacyPolicyAction } from 'store/privacyPolicy';

export function usePrivacyPolicy(guestPortalId, { tourRequest } = {}) {
  const dispatch = useDispatch();
  const { data, isLoading, failureReason } = useQuery(
    [GP_PRIVACY_POLICY, guestPortalId],
    tourRequest ? getTourRequestPrivacyPolicy : getGuestPortalPrivacyPolicy,
    {
      staleTime: 5000,
      retry: Infinity,
      retryDelay: 5000,
    },
  );

  useEffect(() => {
    if (data) {
      dispatch(setPrivacyPolicyAction(data));
    }
  }, [dispatch, data]);

  return {
    data,
    isLoading,
    failureReason,
  };
}
